<script>
  import { store } from '$client';
  import { onMount } from 'svelte';
  const { alert } = store;

  let elClicked = false;
  const alertListener = () => (elClicked = true);
  const windowListener = () => {
    if (elClicked) return void (elClicked = false);
    return void alert.set(null);
  };

  onMount(() => {
    const el = document.getElementById('alert');
    el.addEventListener('click', alertListener);
    window.addEventListener('click', windowListener);
    return () => {
      el.removeEventListener('click', alertListener);
      window.removeEventListener('click', windowListener);
    };
  });
</script>

<dialog id="alert" open={!!$alert} style="display: {$alert ? 'flex' : 'none'};">
  <div>
    <h2>{$alert?.header ?? 'Заявка на вывоз ненужных вещей'}</h2>
    <button aria-label="Закрыть модальное окно" on:click={() => alert.set(null)} />
  </div>
  {#if $alert?.description}
    <p>{@html $alert.description}</p>
  {/if}
  <button on:click={() => alert.set(null)}>{$alert?.button ?? 'Отправить'}</button>
</dialog>

<style lang="scss">
  dialog {
    position: fixed;
    top: 20px;
    left: 50%;
    z-index: 200;
    display: none;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    min-width: 640px;
    max-width: 640px;
    max-height: 640px;
    padding: 28px 40px;
    overflow-y: auto;
    background: #fff;
    border: none;
    border-radius: 10px;
    box-shadow: 0 0 20px rgb(0 0 0 / 10%);
    transform: translateX(-50%);
    transition: transform 0.4s ease-in-out;

    @media only screen and (max-width: 767.98px) {
      width: calc(100% - 40px);
      min-width: auto;
      padding: 10px 15px;
    }

    div {
      display: inline-flex;
      gap: 10px;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      margin-bottom: 20px;

      button {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 25px;
        height: 25px;

        @media only screen and (max-width: 767.98px) {
          width: 20px;
          height: 20px;
        }

        &::after,
        &::before {
          position: absolute;
          display: block;
          width: 3px;
          height: 100%;
          background: #2c333c;
          content: '';
        }

        &::after {
          transform: rotate(45deg);
        }

        &::before {
          transform: rotate(-45deg);
        }
      }
    }

    h2 {
      color: #2c333c;
      font-weight: bold;
      font-size: 24px;
      font-family: Vela Sans;
      font-style: normal;
      line-height: 140%; /* 33.6px */

      @media only screen and (max-width: 767.98px) {
        font-size: 20px;
      }
    }

    p,
    :global(a) {
      color: #77818f;
      font-weight: normal;
      font-size: 16px;
      font-family: Vela Sans;
      font-style: normal;
      line-height: 130%; /* 20.8px */

      @media only screen and (max-width: 767.98px) {
        font-size: 14px;
      }
    }

    > button {
      width: 100%;
      margin-top: 50px;
      padding: 18px 40px;
      background: #22eaac;
      border-radius: 5px;
    }
  }
</style>
